import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Condition = () => {
  return(
    <SettingsMetaData propertyName={"AssertCondition"} viewPropertyName={"Asset Condition"} />
  )
};

export default Condition;
